var aOldSearch = [];
var searchResultContainer;
var searchUrl = $("#instantsearch").data("search-url");
var autocomplete = searchUrl + '?search=%q%';
var q, oDelayedSearchTimer, cache = 0;
var iWaitBeforeSearch = 300;
var iWaitBeforeHideOnBlur = 5000;

function searchWarmUp(){
    if($("#SearchTopText").length){
        $.ajax({
        url: searchUrl + '?autosuggest=true&eComQuery=warmup'
        });
    } 
}

function productSearch(){
    $(function () {
        searchResultContainer = $('#searchResult');
        searchResultContainer.hover(function () {
            searchResultContainer.toggleClass('hasFocus');
            if (!searchResultContainer.hasClass('hasFocus')) {
                oSearchField.trigger('blur');
            }
        });
        var oSearchField = $('#SearchTopText');
        oSearchField.keyup(function (e) {
            if(e.which != 38 && e.which != 40 && e.which != 13){
                active = 0;
                q = $.trim($(this).val());
                if (typeof oDelayedSearchTimer != 'undefined') {
                    window.clearTimeout(oDelayedSearchTimer);
                }
                if (q.length > 1) {
                    oDelayedSearchTimer = window.setTimeout(function () { doSearch(q); }, iWaitBeforeSearch);
                } else {
                    if (cache > 0) { 
                        searchResultContainer.fadeTo('fast', 0).css('display','none');
                    }
                }
            }
        });
        oSearchField.blur(function (e) {
            window.setTimeout(function () {
                if (!searchResultContainer.hasClass('hasFocus')) {
                    searchResultContainer.fadeTo('fast', 0).css('display','none');
                }
            }, iWaitBeforeHideOnBlur);
        });
    });
}

function doSearch(q) {
    if (q !== ''){
        if (typeof aOldSearch[q] != 'undefined') {
            searchResultContainer.html(aOldSearch[q]).fadeTo('fast', 1);
        } else {
            searchResultContainer.load(autocomplete.replace(/%q%/g, encodeURIComponent(q)), {}, function () {
                aOldSearch[q] = searchResultContainer.fadeTo('fast', 1).html();
                cache++;
            });
        }
    } 
    else{
        searchResultContainer.fadeTo('fast', 0);
    }
}

function addProductToPreview(e){
    var _target;
    if(e === undefined){
        _target = $(".searchItem.result.active");
    }
    else{
        _target = $(e.target).closest(".searchItem");
    }

    if(_target.hasClass("result")){
        var _preview = $(".productPreview");

        _preview.find("img").attr("src", _target.data("image"));
        _preview.find(".searchName").text(_target.data("name"));
        _preview.show().addClass("productSet");
        $("#searchResult").hide();

        $("#productIdField").val(_target.data("productid"));

        if(_target.data("productid") == "PROD10"){
            $(".defaultProduct").slideDown(500).find("input").prop("disabled", false).attr("validate", "true");
            _preview.find(".searchProdId").text("");
            initProductValidation();
        }
        else{
            _preview.find(".searchProdId").text(_target.data("productid"));
        }
    }
}

function removeProductFromPreview(){
    $("#SearchTopText").val("");
    $("#productIdField").val("");
    $(".productPreview").hide().removeClass("productSet");
    $(".defaultProduct").slideUp(500).find("input").prop("disabled", true).attr("validate", "false");
    initProductValidation();
    active = 0;
}

var active = 0;
function navigateSearch(e){
    var results = $(".searchItem.result").length;
    switch(e.which){
        case 38:
            navigateSearchUp(results);
            e.preventDefault();
        break;

        case 40:
            navigateSearchDown(results);
            e.preventDefault();
        break;

        case 13:
            addProductToPreview();
            e.preventDefault();
        break;
    }
}

function navigateSearchUp(results){
    $(".searchItem.result[data-order=" + active + "]").removeClass("active");
    if(active === 0){
        active = results;
    }
    else{
        active -= 1;
    }    
    $(".searchItem.result[data-order=" + active + "]").addClass("active");
}

function navigateSearchDown(results){
    $(".searchItem.result[data-order=" + active + "]").removeClass("active");
    if(active == results){
        active = 0;
    }
    else{
        active += 1;
    } 
    $(".searchItem.result[data-order=" + active + "]").addClass("active");
}